import Vue from "vue";

function duration (time) {
  let formattedDuration = Vue.moment.duration(time);
  let result = '';
  let days = formattedDuration.get('days');
  if (days > 0) {
    result += `${days}d `;
  }
  let hours = formattedDuration.get('hours');
  if (hours > 0) {
    result += `${hours}h `;
  }
  let minutes = formattedDuration.get('minutes');
  if (minutes > 0) {
    result += `${minutes}m`;
  }
  return result;
}

export default duration;